import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'mobx-react';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { Helmet } from 'react-helmet';
import theme from '@styles/theme';
import stores from '@stores';
import RoutesControl from './routes';

const App = () => {
  return (
    <BrowserRouter>
      <Provider {...stores}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <RoutesControl />
          <Helmet>
            <script type="text/javascript" src="//map.search.ch/api/map.js?lang=de"></script>
          </Helmet>
        </ThemeProvider>
      </Provider>
    </BrowserRouter>
  );
};

export default App;
